import { PrivateRoute as _PrivateRoute } from '@bluefalcon/components-package';
import { BF_TOKEN } from '../../constants/cookies.constants';

type PrivateRouteProps = {
    Component: any;
};

export function PrivateRoute({ Component }: PrivateRouteProps) {
    return (
        <_PrivateRoute
            Component={Component}
            routeOnError={"/login"}
            tokenKey={BF_TOKEN}
        />
    );
};
